import { useCallback } from 'react'
import { getGetInnerForcesEnvelopeQueryKey } from '@api/inner-forces-envelope/inner-forces-envelope'
import { useQueryClient } from '@tanstack/react-query'

/**
 * Drop all inner forces envelopes of a project. The envelope (Vz, My and the deflection uz, which
 * also depends on the stiffness of the cross section) is computed from the stored member results,
 * so it has to be refetched whenever those are recomputed, e.g. after a cross section change. It
 * is an orval-generated query keyed per element (one URL string per key), so the project's
 * envelopes are matched by prefix; with staleTime Infinity they would otherwise show old values.
 */
const useInnerForcesEnvelopeInvalidation = () => {
  const queryClient = useQueryClient()

  return useCallback(
    (projectId: string) => {
      const keyPrefix = getGetInnerForcesEnvelopeQueryKey(projectId, '')[0]
      return queryClient.invalidateQueries({
        predicate: ({ queryKey: [key] }) => typeof key === 'string' && key.startsWith(keyPrefix),
      })
    },
    [queryClient],
  )
}

export default useInnerForcesEnvelopeInvalidation
